module.exports = __webpack_public_path__ + "static/media/star.43804b93.svg";